import { c as _c } from "react/compiler-runtime";
import { FormInput } from '@systemeio/ui';
import React from 'react';
import { useEmailOptions } from 'shared/components/dashboard-mail-editor/hooks/use-email-options';
import { DisclosureBox } from 'shared/components/disclosure-box';
import { SectionMessage } from 'shared/components/section-message';
import SenderEmailSelect from 'shared/components/sender-email-select';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { isBlacklistEmailDomain } from 'shared/utils/is-blacklist-email-domain';
import { twJoin } from 'tailwind-merge';
import { DashboardMailEditorCommonProps, ExtendedState } from '../types/common';
export interface EmailSettingsBlockProps<T extends ExtendedState> extends Pick<DashboardMailEditorCommonProps<T>, 'isPreFetching' | 'inModal' | 'errors' | 'tempState' | 'onChangeEmail' | 'disabled'> {}
const EmailSettingsBlock = t0 => {
  const $ = _c(39);
  const {
    disabled,
    errors,
    inModal,
    isPreFetching,
    onChangeEmail,
    tempState
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    data: options
  } = useEmailOptions();
  const isError = !!errors.fromName || !!errors.fromEmail;
  const t1 = inModal && "border border-text-secondary/30 rounded-lg";
  const t2 = isError && "border-danger";
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = twJoin(t1, t2);
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t) {
    t4 = t("dashboard.email.email_settings");
    $[3] = t;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t4) {
    t5 = <b className="text-text-primary text-start text-[17px]">{t4}</b>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = isPreFetching || !options;
  const t7 = tempState?.fromName || "";
  let t8;
  if ($[7] !== onChangeEmail || $[8] !== tempState) {
    t8 = e => tempState && onChangeEmail({
      ...tempState,
      fromName: e.target.value
    });
    $[7] = onChangeEmail;
    $[8] = tempState;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const t9 = errors.fromName;
  let t10;
  if ($[10] !== t) {
    t10 = t("dashboard.email.sender_name");
    $[10] = t;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== disabled || $[13] !== errors.fromName || $[14] !== t10 || $[15] !== t6 || $[16] !== t7 || $[17] !== t8) {
    t11 = <FormInput disabled={disabled} isPreFetching={t6} value={t7} onChange={t8} error={t9} required={true} label={t10} />;
    $[12] = disabled;
    $[13] = errors.fromName;
    $[14] = t10;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t || $[20] !== tempState?.fromEmail) {
    t12 = !!tempState?.fromEmail && isBlacklistEmailDomain(tempState?.fromEmail) && <SectionMessage>{t("dashboard.email.new_google_policy_warning_message")}</SectionMessage>;
    $[19] = t;
    $[20] = tempState?.fromEmail;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  const t13 = tempState?.fromEmail || "";
  let t14;
  if ($[22] !== onChangeEmail || $[23] !== tempState) {
    t14 = value => tempState && onChangeEmail({
      ...tempState,
      fromEmail: value
    });
    $[22] = onChangeEmail;
    $[23] = tempState;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== disabled || $[26] !== errors.fromEmail || $[27] !== isPreFetching || $[28] !== t13 || $[29] !== t14) {
    t15 = <SenderEmailSelect value={t13} onChange={t14} error={errors.fromEmail} required={true} disabled={disabled} isPreFetching={isPreFetching} />;
    $[25] = disabled;
    $[26] = errors.fromEmail;
    $[27] = isPreFetching;
    $[28] = t13;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t11 || $[32] !== t12 || $[33] !== t15) {
    t16 = <div className="flex flex-col gap-5">{t11}{t12}{t15}</div>;
    $[31] = t11;
    $[32] = t12;
    $[33] = t15;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== t16 || $[36] !== t3 || $[37] !== t5) {
    t17 = <DisclosureBox wrapperClassName={t3} defaultOpen={true} title={t5}>{t16}</DisclosureBox>;
    $[35] = t16;
    $[36] = t3;
    $[37] = t5;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  return t17;
};
export default EmailSettingsBlock;